import styled from 'styled-components';

const ButtonMedium = styled.button`
  min-height: ${({ theme }) => theme.formElementBaseHeight};
  height: ${({ theme }) => theme.formElementBaseHeight};
  padding: 0 ${({ theme }) => theme.spacing01};
  font-size: ${({ theme }) => theme.fontSize03};
  border-radius: ${({ theme }) => theme.borderRadius};
  border: none;
  font-weight: ${({ theme }) => theme.fontWeightMedium};
  cursor: pointer;
`;

export const ButtonSmall = styled.button`
  border: none;
  font-weight: ${({ theme }) => theme.fontWeightMedium};
  cursor: pointer;
  min-height: ${({ theme }) => theme.formElementBaseHeightSmall};
  padding: 0 ${({ theme }) => theme.spacing02};
  border-radius: ${({ theme }) => theme.borderRadius};
  font-size: ${({ theme }) => theme.fontSize03};
`;

export const ButtonPrimarySmall = styled(ButtonSmall)`
  background: ${({ theme }) => theme.colorPrimary50};
  border-radius: ${({ theme }) => theme.borderRadius};
  color: white;
  transition: ${({ theme }) => theme.hoverTransitionSpeed} linear background;
  :hover {
    background: ${({ theme }) => theme.colorPrimary70};
    transition: ${({ theme }) => theme.hoverTransitionSpeed} linear background;
  }
`;

export const ButtonSecondarySmall = styled(ButtonSmall)`
  border: 1px solid ${({ theme }) => theme.colorPrimary50};
  color: ${({ theme }) => theme.colorPrimary70};
  background: none;
  :hover {
    border: 1px solid ${({ theme }) => theme.colorPrimary70};
    color: ${({ theme }) => theme.colorPrimary50};
  }
`;

export const ButtonPrimaryMedium = styled(ButtonMedium)`
  background: ${({ theme }) => theme.colorPrimary50};
  color: white;
  transition: ${({ theme }) => theme.hoverTransitionSpeed} linear background;
  :hover {
    background: ${({ theme }) => theme.colorPrimary70};
    transition: ${({ theme }) => theme.hoverTransitionSpeed} linear background;
  }
`;
export const ButtonSecondaryMedium = styled(ButtonMedium)`
  border: 2px solid ${({ theme }) => theme.colorPrimary50};
  color: ${({ theme }) => theme.colorPrimary70};
  background: white;
  :hover {
    border: 2px solid ${({ theme }) => theme.colorPrimary70};
    color: ${({ theme }) => theme.colorPrimary50};
  }
`;

export const ButtonWhiteMedium = styled(ButtonMedium)`
  color: ${({ theme }) => theme.colorText50};
  background: white;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  width: 100%;
  display: flex;
  align-items: center;
  :hover {
    color: ${({ theme }) => theme.colorPrimary50};
  }
`;

export const ButtonTertiary = styled.button`
  color: ${({ theme }) => theme.colorPrimary70};
  font-weight: ${({ theme }) => theme.fontWeightMedium};
  border: none;
  background: none;
  font-size: ${({ theme }) => theme.fontSize03};

  :hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;
